<template>
  <div>
    <Head title="Tambah Pengumuman" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/announcements">Pengumuman</Link>
      <span class="text-indigo-400 font-medium">/</span> Tambah
    </h1>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full" label="Judul Pengumuman" />
          <text-editor v-model="form.content" :error="form.errors.content" class="pb-8 pr-6 w-full" label="Konten Pengumuman (HTML)" />
          <select-input v-model="form.is_active" :error="form.errors.is_active" class="pb-8 pr-6 w-full lg:w-1/2" label="Status">
            <option :value="true">Aktif</option>
            <option :value="false">Tidak Aktif</option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-2" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextEditor from '@/Shared/TextEditor'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TextEditor,
    SelectInput,
    FontAwesomeIcon,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: '',
        content: '',
        is_active: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/announcements')
    },
  },
}
</script>
